import { useQuery, useMutation } from '@eika-infrastruktur/react-query';

import {
    getAntiMoneyLaunderingAssignments,
    sendAntiMoneyLaunderingAssignmentsNotification,
} from '../services/antiMoneyLaunderingAssignmentService';

export const useAntiMoneyLaunderingAssignment = () =>
    useQuery('antiMoneyLaundering', () => getAntiMoneyLaunderingAssignments());

export const useSendAntiMoneyLaunderingNotification = () =>
    useMutation((customerId: string) => sendAntiMoneyLaunderingAssignmentsNotification(customerId));
